import { render, staticRenderFns } from "./ClientsView.vue?vue&type=template&id=4dd5a8ae&"
import script from "./ClientsView.vue?vue&type=script&lang=js&"
export * from "./ClientsView.vue?vue&type=script&lang=js&"
import style0 from "./ClientsView.vue?vue&type=style&index=0&id=4dd5a8ae&prod&lang=css&"
import style1 from "./ClientsView.vue?vue&type=style&index=1&id=4dd5a8ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports